import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  validatePhoneNumber(state, { phoneNumber, countryCode }) {
    return axios.get(
      `/twilio-api/validate-phone-number?phoneNumber=${phoneNumber}&countryCode=${countryCode}`,
    )
      .then(({ data }) => (data))
      .catch((err) => { throw err; });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};